import packageInfo from '../../package.json';

export const environment = {
    production: false,
    appName: 'IvstoreMobile Dev',
    backendDomain: 'https://api.ivstore.fr',
    version: packageInfo.version,
    secret: 'My mega secret',
    hmr: false,
};
